import * as React from "react";
import './videoThumbnail.css';
type State = {}

type Thumbnail = {
    url: string;
};

type Snippet = {
    title: string;
    resourceId: VideoDetails;
    thumbnails: {
        medium: Thumbnail;
        standard: Thumbnail;
    };
    description: string;
};

export type Video = {
    snippet: Snippet;
    id: VideoDetails;
};

export type VideoDetails = {
    kind: string;
    videoId: string;
};

interface Props {
    video: Video;
    key: string;
    onClick: (val: Video) => void;
}

export default class VideoThumbnail extends React.Component<Props, State> {
    render() {
        const {snippet} = this.props.video;
        const {title, thumbnails, description} = snippet;
        console.log({thumbnails})
        return (
            <div
                className="max-w-sm rounded overflow-hidden shadow-lg m-2 cursor-pointer"
                onClick={() => this.props.onClick(this.props.video)}
            >
                <div className="image-container">
                    <img className="w-full" src={thumbnails.medium.url} alt={title} />
                    <div className="image-overlay"></div>
                    <div className="play-button">
                        <svg 
                            width="100%" 
                            height="100%" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true">
                            <path 
                                d="M8 5v14l11-7z" 
                                fill="#FFFFFF"/>
                        </svg>
                    </div>
                </div>
                <div className="px-6 py-4 text-content">
                    <div className="font-bold text-xl mb-2">{title}</div>
                    <p className="text-gray-700 text-base">{description}</p>
                </div>
            </div>
        );
    }
}